const TEAM_LOGOS: Record<string, string> = {
  "المصري": "/manus-storage/1031_852a096d.png",
  "الهلال": "/manus-storage/2930_3876e828.png",
  "النصر": "/manus-storage/2931_24e9975b.png",
  "القادسية": "/manus-storage/2937_8935f2fa.png",
  "نيوم": "/manus-storage/10513_9e645810.png",
  "أبها": "/manus-storage/2951_da9dc544.png",
  "عجمان": "/manus-storage/2879_19b74237.png",
  "الأهلي القطري": "/manus-storage/2896_0f2a81b0.png",
  "العين": "/manus-storage/2865_a6182944.png",
  "الخليج": "/manus-storage/2928_f8c663ac.png",
  "الأخدود": "/manus-storage/10509_96132759.png",
  "السد": "/manus-storage/2895_2b5d17d4.png",
  "الشباب": "/manus-storage/2940_8bf9b893.png",
  "التعاون": "/manus-storage/2936_d7db10fa.png",
  "الأهلي السعودي": "/manus-storage/2929_6563eafc.png",
  "الظفرة": "/manus-storage/2873_fb5310ba.png",
  "الدحيل": "/manus-storage/2904_984d0ad4.png",
  "الاتفاق": "/manus-storage/2934_23991787.png",
  "الفتح": "/manus-storage/2931_24e9975b.png",
  "السيلية": "/manus-storage/2898_8c5070c6.png",
  "أسيوط للبترول": "/manus-storage/18021_e2c2bac4.png",
  "أتلتيك بلباو": "/manus-storage/531_a9c2d044.png",
  "أوكسير": "/manus-storage/108_b3c1089b.png",
  "برينتفورد": "/manus-storage/55_d0888f31.png",
  "سيلتا فيغو": "/manus-storage/538_316dbe13.png",
  "كريستال بالاس": "/manus-storage/52_34ab7ac5.png",
  "طلائع الجيش": "/manus-storage/1039_1c0c9bb0.png",
  "المقاولون العرب": "/manus-storage/1575_c5bae65e.png",
  "إسبانيول": "/manus-storage/540_c9cd3d83.png",
  "تروا": "/manus-storage/110_a3b399bf.png",
  "إيفرتون": "/manus-storage/45_6307ac7f.png",
  "فنربخشة": "/manus-storage/611_5db22657.png",
  "غزل المحلة": "/manus-storage/13819_d6548d20.png",
  "حتا": "/manus-storage/2869_85fcba68.png",
  "هال سيتي": "/manus-storage/64_f3cbe4dc.png",
  "إيبسويتش": "/manus-storage/57_9b4771a1.png",
  "قاسم باشا": "/manus-storage/1004_44821fb8.png",
  "خورفكان": "/manus-storage/4912_36c47eab.png",
  "قونيا سبور": "/manus-storage/607_765e2ed0.png",
  "لومان": "/manus-storage/1298_d9f84e71.png",
  "لانس": "/manus-storage/116_3b5766d5.png",
  "لوريان": "/manus-storage/97_446da180.png",
  "لييدس": "/manus-storage/63_78944fbf.png",
  "ليدز": "/manus-storage/63_78944fbf.png",
  "ليون": "/manus-storage/80_32b711c5.png",
  "مانشستر يونايتد": "/manus-storage/33_da98c3ed.png",
  "نيس": "/manus-storage/84_8aa028a0.png",
  "نوتنغهام فورست": "/manus-storage/65_94de221e.png",
  "باريس إف سي": "/manus-storage/114_6b3187b8.png",
  "بتروجت": "/manus-storage/1041_26275e26.png",
  "بيراميدز": "/manus-storage/1036_9a6a1df6.png",
  "ريال مدريد": "/manus-storage/541_8ed03239.png",
  "ريز سبور": "/manus-storage/1007_07ceb049.png",
  "سامسون سبور": "/manus-storage/3603_0b6d4a8d.png",
  "إشبيلية": "/manus-storage/536_b9faefdf.png",
  "شباب الأهلي دبي": "/manus-storage/2870_7357f716.png",
  "سموحة": "/manus-storage/1044_ca28bb6a.png",
  "ستاد بريست": "/manus-storage/106_c1c3ef2d.png",
  "سندرلاند": "/manus-storage/746_1cda1d10.png",
  "توتنهام": "/manus-storage/47_f7523301.png",
  "تولوز": "/manus-storage/96_00e80f24.png",
  "فالنسيا": "/manus-storage/532_c0c42914.png",
  "تشوروم": "/manus-storage/6343_5cd17acf.png",
  "مانشستر سيتي": "/manus-storage/50_8fb92fd5.png",
};

export function getTeamLogo(name?: string | null) {
  if (!name) return null;
  const normalized = name.replace(/[\u200B-\u200D\uFEFF]/g, "").replace(/\s+/g, " ").trim();
  return TEAM_LOGOS[normalized] ?? null;
}

export { TEAM_LOGOS };
